// extracted by mini-css-extract-plugin
var _1 = "CopyLinkButton-module__animateUploadProgressBarWidth--HudEv";
var _2 = "CopyLinkButton-module__animatedBackground--CLaHW";
var _3 = "CopyLinkButton-module__copyLinkButton--isRKh";
var _4 = "CopyLinkButton-module__copyLinkButtonIcon--S_d6W";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "copyLinkButton", _4 as "copyLinkButtonIcon" }
